import {
  NJIconButton,
  NJInlineMessage,
} from "@engie-group/fluid-design-system-react";
import { browserReload } from "@genai/browser";
import styles from "./page.module.css";

export const ChatError = ({ message }: { message?: string }) => {
  return (
    <NJInlineMessage variant="error">
      <div
        className={styles["genai-inline-message-content"]}
        data-child-name="njInlineMessageTitle"
      >
        <span>Une erreur est survenue : {message}</span>
        <NJIconButton
          label="Rafraîchir"
          variant="tertiary"
          size="sm"
          icon="refresh"
          onClick={browserReload}
        ></NJIconButton>
      </div>
    </NJInlineMessage>
  );
};
